<template>
    <div>
        <!--Edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header">
                    <h3 class="fw-bold mb-3">Admin</h3>
                    <ul class="breadcrumbs mb-3">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Cadastro de modelos de
                                contrato</a> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item" v-if="User.garid == 0"><a href="#" @click="EditNew()">Incluir Novo</a>
                        </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="ModeloContrato.cmcId" type="text" class="form-control"
                                                placeholder="Id" />
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label>Nome do Modelo</label>
                                            <input v-model="ModeloContrato.cmcNome" type="text" class="form-control"
                                                placeholder="Nome" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2" v-if="User.garid == 0">
                                        <div class="form-group">
                                            <label>Ativo</label>
                                            <select v-model="ModeloContrato.cmcAtivo" class="form-select form-control"
                                                id="defaultSelect">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3" v-if="TipoPessoas != '' && User.garid == 0">
                                        <div class="form-group">
                                            <label>Tipo Pessoa</label>
                                            <select v-model="ModeloContrato.tpeId" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option v-for="optionTipo in TipoPessoas" :key="optionTipo.tpeId"
                                                    :value="optionTipo.tpeId">{{ optionTipo.tpeNome }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2" v-if="TipoPessoas != '' && User.garid == 0">
                                        <div class="form-group">
                                            <label>Tipo Documento</label>
                                            <select v-model="ModeloContrato.tpdId" class="form-select form-control">
                                                <option :value=null>Selecione</option>
                                                <option v-for="optionTipo in TiposDocumentos" :key="optionTipo.tpdId"
                                                    :value="optionTipo.tpdId">{{ optionTipo.tpdNome }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3" v-if="ModeloContrato.tpeId == 1 && User.garid == 0">
                                        <div class="form-group">
                                            <label>Garantidora</label>
                                            <select v-model="ModeloContrato.garId" class="form-select form-control">
                                                <option :value=null>Selecione</option>
                                                <option v-for="optionTipo in ListGarantidorasGeral"
                                                    :key="optionTipo.garId" :value="optionTipo.garId">{{
                                                    optionTipo.garNomeEmpresa }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label>Dados Dinâmicos</label>
                                            <ckeditor :editor="editor" @ready="onReady"
                                                v-model="ModeloContrato.cmcTexto1" :config="$ckconfig"  :style="User.garid != 0
    ? { backgroundColor: '#f5f5f5', opacity: 0.6, height: '200px' } : {height: '300px'}"
                                                :disabled="User.garid != 0"></ckeditor>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label>Conteúdo Editável</label>
                                            <ckeditor :editor="editor" @ready="onReady"
                                                v-model="ModeloContrato.cmcTexto2" :config="$ckconfig"
                                                style="height: 800px;"></ckeditor>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label>Dados Dinâmicos</label>
                                            <ckeditor :editor="editor" @ready="onReady"
                                                v-model="ModeloContrato.cmcTexto3" :config="$ckconfig"
                                                :disabled="User.garid != 0" :style="User.garid != 0
    ? { backgroundColor: '#f5f5f5', opacity: 0.6, height: '200px' } : {height: '300px'}"></ckeditor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action">
                        <button v-if="ModeloContrato.cmcId != 0" type="button" class="btn btn-success"
                            style="color:#ffffff;" @click="Put()">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()" class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de modelos de contrato</h4>
                                    <a v-if="User.garid == 0" href="#" @click="EditNew()"
                                        class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body" v-if="TipoPessoas != '' && ListGarantidorasGeral != ''">
                                <v-row>
                                    <v-col cols="12" md="6" style="padding-bottom: 30px;">
                                        <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <easy-data-table :headers="headers" :items="ModeloContratos" v-model="itemsSelected"
                                    alternating theme-color="#364f66" table-class-name="customize-table"
                                    header-text-direction="center" body-text-direction="center"
                                    rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                                    <template #item-cmcAtivo="item">
                                        <span>{{ item.cmcAtivo ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-tpeId="item">
                                        <span>{{item.tpeId != null ? TipoPessoas.filter(x => x.tpeId ==
                                            item.tpeId)[0].tpeNome : '' }}</span>
                                    </template>
                                    <template #item-garId="item">
                                        <span>{{item.garId != null ? ListGarantidorasGeral.filter(x => x.garId ==
                                            item.garId)[0].garNomeEmpresa : '' }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                            <v-icon class="editiconcor">mdi-file-edit</v-icon>
                                            <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                                        </v-btn>

                                        <v-btn v-if="User.garid == 0" icon
                                            @click="dialogReplace = true; SelectedCmcId = item.cmcId" variant="text">
                                            <v-icon>mdi-file-replace</v-icon>
                                            <v-tooltip activator="parent" location="top">Replicar</v-tooltip>
                                        </v-btn>

                                        <v-btn v-if="User.garid == 0" icon @click="DeleteGrid(item)" variant="text">
                                            <v-icon class="deliconcor">mdi-delete-forever</v-icon>
                                            <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                                        </v-btn>


                                    </template>
                                </easy-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--modal produto garantia-->
        <v-row justify="center">
            <v-dialog v-model="dialogReplace" persistent transition="dialog-bottom-transition" max-width="300">
                <v-card>
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Replicar Documento</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row v-show="false">
                                    <v-col cols="12" md="4">
                                        <label>Id Contrato</label>
                                        <input v-model="SelectedCmcId" type="text" class="form-control"
                                            placeholder="Id" />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <label>Garantidora</label>
                                        <select v-model="SelectedGarId" class="form-select form-control">
                                            <option :value=null>Selecione</option>
                                            <option v-for="optionTipo in ListGarantidorasGeral" :key="optionTipo.garId"
                                                :value="optionTipo.garId">{{ optionTipo.garNomeEmpresa }}</option>
                                        </select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn style="padding: 5px;margin: 5px;font-size: 12px;color:#000000"
                            @click.prevent="dialogReplace = !dialogReplace">Cancelar</v-btn>
                        <v-btn class="btn btn-success" style="padding: 5px;margin: 5px;font-size: 12px;color:#ffffff"
                            @click.prevent="ReplicarContrato(SelectedCmcId, SelectedGarId)">Replicar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>

</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

export default {
    name: 'CadastroModeloContratoView',
    components: {
        EasyDataTable
    },
    data: () => ({
        EditView: false,
        editor: DecoupledEditor,
        User: {
           garid: 0,
        },
        ModeloContrato: {
            cmcId: 0,
            cmcNome: '',
            cmcAtivo: '',
            cmcTexto1: '',
            cmcTexto2: '',
            cmcTexto3: '',
            tpeId: '',
            garId: null,
            tpdId: null,
        },
        ModeloContratos: [],
        selectedAtivo: null,
        headers: [
            { text: "Id", value: "cmcId", sortable: true, },
            { text: "Nome", value: "cmcNome", sortable: true, },
            { text: "Ativo", value: "cmcAtivo", sortable: true, },
            { text: "Tipo", value: "tpeId", sortable: true, },
            { text: "Garantidora", value: "garId", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
        TipoPessoas: [],
        ListGarantidorasGeral: [],
        TiposDocumentos: [],
        dialogReplace: false,
        SelectedGarId: null,
        SelectedCmcId: '',
        ModeloContratoNovo: [],
    }),
    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        //edit
        EditNew() {
            this.EditView = true;
            this.ModeloContrato.cmcId = 0;
            this.ModeloContrato.cmcNome = '';
            this.ModeloContrato.cmcAtivo = '';
            this.ModeloContrato.cmcTexto1 = '';
            this.ModeloContrato.cmcTexto2 = '';
            this.ModeloContrato.cmcTexto3 = '';
            this.ModeloContrato.tpeId = '';
            this.ModeloContrato.garId = null;
            this.ModeloContrato.tpdId = null;
        },
        EditGrid(item) {
            this.EditView = true;
            if (item.cmcId != '') {
                axios.get(`/Telas/ModelosContrato/GetById/` + item.cmcId)
                    .then(response => {
                        this.ModeloContrato = response.data;
                    });
            }
        },
        Add() {
            if (this.ModeloContrato.cmcNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.ModeloContrato.cmcAtivo === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.ModeloContrato.tpeId === '') {
                this.$mensagemAviso("Tipo Pessoa Obrigatório.")
            }
            else if (this.ModeloContrato.tpdId === '') {
                this.$mensagemAviso("Tipo Documento Obrigatório.")
            }
            else {
                axios.post(`/Telas/ModelosContrato/Add`, this.ModeloContrato)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                        }
                    });
            }
        },
        ReplicarContrato(_selectedCmcId, _selectedGarId) {
            axios.get(`/Telas/ModelosContrato/GetById/` + _selectedCmcId)
                .then(response => {
                    this.ModeloContratoNovo = response.data;
                    this.ModeloContratoNovo.cmcId = 0;
                    this.ModeloContratoNovo.garId = _selectedGarId;

                     axios.post(`/Telas/ModelosContrato/Add`, this.ModeloContratoNovo)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                            this.dialogReplace = false;
                        }
                    });
                });

        },
        Put() {
            if (this.ModeloContrato.cmcNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.ModeloContrato.cmcAtivo === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.ModeloContrato.tpeId === '') {
                this.$mensagemAviso("Tipo Pessoa Obrigatório.")
            }
            else if (this.ModeloContrato.tpdId === '') {
                this.$mensagemAviso("Tipo Documento Obrigatório.")
            }
            else {
                axios.put(`/Telas/ModelosContrato/Update`, this.ModeloContrato)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                        }
                    });
            }
        },
        EditCancel() {
            //window.location.reload();
            this.$router.go(0);
        },
        //edit
        DeleteGrid(item) {
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // Lógica para excluir o item
                        const param1 = item.cmcId;
                        axios.delete(`/Telas/ModelosContrato/Delete/${param1}`)
                            .then(response => {
                                if (response.stacmc == 200) {
                                    this.$mensagemAvisoSucesso("Registro Excluido.")
                                    this.Get();
                                }
                            });
                    }
                });
        },
        async Get() {
            
            this.EditView = false;
            await axios.get(`/Telas/ModelosContrato/GetDados`)
               .then(response => {
                this.ModeloContratos = response.data.modelosContratos;
                this.TipoPessoas = response.data.tiposPessoas;
                this.ListGarantidorasGeral = response.data.garGarantidoras.filter(x => x.garAtivo).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(
                        b.garNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                        )
                    );
                this.TiposDocumentos = response.data.tipoDocumentos;
                this.User.garid = response.data.garId;
           });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
